import { addACHDiscount, deleteACHDiscount } from '../../store/actions/membershipActions';
import { getUserInfo, updateBillingMethod } from '../../store/actions/accountActions'

export const ACHDiscountWrapper = (accountResp, type, currentUser, dispatch) => {
    console.log(accountResp, type, currentUser);
    let discountExistsNow = false;
    let associatedSubscriptionId = null;
    let subscriptionIdForDiscount = null;
    let defaultSource = null;
    let isDefaultSourceBankAcct;
    let switchBillingMethod = false;

    if (accountResp) {
        defaultSource = accountResp.default_source;
    }
    if (accountResp && accountResp.subscriptions && accountResp.subscriptions.data && accountResp.subscriptions.data.length > 0) {
        accountResp.subscriptions.data.forEach((subscription) => {
            if (!subscriptionIdForDiscount) {
                subscriptionIdForDiscount = subscription.id;
            }
            if (subscription.discount && subscription.discount.coupon && subscription.discount.coupon.id === 'ACHDISCOUNT') {
                discountExistsNow = true;
                associatedSubscriptionId = subscription.id;
            }
            if (subscription.billing === 'send_invoice') {
                switchBillingMethod = true;
            }

        })

        if (accountResp && accountResp.sources && accountResp.sources.data && accountResp.sources.data.length > 0) {
            accountResp.sources.data.forEach((source) => {
                if ((source.id === defaultSource) && source.object === 'bank_account') {
                    isDefaultSourceBankAcct = true;
                }
            })
        }
    }
    console.log("discountExistsNow" + discountExistsNow);
    console.log("associatedSubscriptionId" + associatedSubscriptionId);
    console.log("isDefaultSourceBankAcct" + isDefaultSourceBankAcct);

    if (discountExistsNow && associatedSubscriptionId && type === 'delete') {
        // Dispatch 
        dispatch(deleteACHDiscount(associatedSubscriptionId, (err, response) => {

            dispatch(getUserInfo(currentUser.userId, () => {
            }))

        }))
    }
    // Check if discount does not exist and add discount to subscription if any exist
    // 1) apply as we know this is a bank account
    ////2) Here check if the current default source is bank account - if yes - check if there is discount already applied - if not apply the discount  
    //3) After verification - check if default source is bank acct & check if the discount was already applied ; if not add the discount

    if (!discountExistsNow && isDefaultSourceBankAcct && subscriptionIdForDiscount && type === 'apply') {

        dispatch(addACHDiscount(subscriptionIdForDiscount, () => {

            dispatch(getUserInfo(currentUser.userId, () => {
            }))

        }))

    }

    if (discountExistsNow && !isDefaultSourceBankAcct && associatedSubscriptionId && type === 'apply') {
        dispatch(deleteACHDiscount(associatedSubscriptionId, (err, response) => {

            dispatch(getUserInfo(currentUser.userId, () => {
            }))

        }))
    }

    // Here check if the current default source is bank account - if not revert discount 
    // check if not bank account and delete
    if ((discountExistsNow && !isDefaultSourceBankAcct && associatedSubscriptionId) && type === 'checkAndDelete') {
        dispatch(deleteACHDiscount(associatedSubscriptionId, (err, response) => {

            dispatch(getUserInfo(currentUser.userId, () => {
            }))

        }))
    }

    // if bank account & !discountExist 
    if ((!discountExistsNow && isDefaultSourceBankAcct && subscriptionIdForDiscount) && type === 'checkAndDelete') {
        dispatch(addACHDiscount(subscriptionIdForDiscount, () => {

            dispatch(getUserInfo(currentUser.userId, () => {
            }))

        }))
    }

    if (switchBillingMethod) {
        dispatch(updateBillingMethod('charge_automatically', subscriptionIdForDiscount))
    }


}
